/**
 * Created by mukund on 9/6/17.
 */
angular.module('mediacloudApp')
    .directive('captioner', ['BatchService', 'UploadErrors', function(BatchService, UploadErrors) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/captioner/captioner.html',
            scope: {
                batch: '=',
                tracker: '=',
                errors: '=',
                upload: '&',
                cancelUpload: '&'
            },
            link: function (scope, element, attrs) {

                scope.setFileCaptioningOption = function(file){
                    file.sendForCaptioning = !file.sendForCaptioning;
                    scope.all.selectCount = file.sendForCaptioning ? scope.all.selectCount + 1 : scope.all.selectCount - 1;
                };

                scope.setBatchCaptioningOption = function(){
                    scope.batch.sendForCaptioning = !scope.batch.sendForCaptioning;
                    angular.forEach(scope.batch.files, function(file){ file.sendForCaptioning = scope.batch.sendForCaptioning });
                    if(scope.batch.sendForCaptioning){
                        scope.all.selectCount = scope.batch.files.length;
                    } else {
                        scope.all.selectCount = 0;
                    }
                };

                scope.$watch('all.selectCount', function(){
                    if(scope.batch) {
                        scope.batch.sendForCaptioning = (scope.all.selectCount && scope.all.selectCount === scope.batch.files.length);
                    }
                });

                scope.closeCaptioner = function(){
                    scope.cancelUpload();
                    clearCaptioningSelection();
                };

                scope.uploadFiles = function(skipCaptioning){
                    if(skipCaptioning || scope.all.selectCount) {
                        if(skipCaptioning){
                            scope.batch.sendForCaptioning = false;
                            angular.forEach(scope.batch.files, function(file){ file.sendForCaptioning = false });
                        }
                        $('#watsonmodal').modal('hide');
                        scope.upload();
                        clearCaptioningSelection();
                    }
                };

                var clearCaptioningSelection = function(){
                    scope.all = { selectCount: 0 };
                };

                clearCaptioningSelection();
            }
        }
    }]);
